import React, { useRef, useState } from 'react';
import {
  CForm,
  CFormLabel,
  CFormInput,
  CFormTextarea,
  CButton,
  CAlert
} from '@coreui/react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import axios from "axios";
import { Editor } from '@tinymce/tinymce-react';

const tokenStr = localStorage.getItem('user');
const header = { headers: { "Authorization": `Bearer ${tokenStr}` } };

export async function LoaderPaymentMethodsUpdate({ params }) {
  if (Object.keys(params).length != 0) {
    let res = await axios.get(process.env.REACT_APP_SERVER_URL + '/api/pm_methods/' + params.pid, header).then((response) => {
      return response;
    });
    return res;
  }
  return false;
}
const PaymentMethodsForm = () => {
  const navigate = useNavigate()
  const { data } = useLoaderData();
  const [name, setName] = useState((data != undefined) ? data.name : '');
  const [slug, setSlug] = useState((data != undefined) ? data.slug : '');
  const [value, setValue] = useState((data != undefined) ? data.value : '');
  const [publicKey, setPublicKey] = useState((data != undefined) ? data.publicKey : '');
  const [privateKey, setPrivateKey] = useState((data != undefined) ? data.privateKey : '')
  const [validated, setValidated] = useState(false)
  const [visibleSuccess, setVisibleSuccess] = useState(false)
  const [visibleError, setVisibleError] = useState(false)
  const editorRef = useRef(null);
  // Ключ для Editor
  const apiKey = process.env.REACT_APP_TINYMCE_API_KEY;

  const handleSubmit = event => {
    event.preventDefault();
    let v = false;
    let success = false;
    const form = event.currentTarget
    if (form.checkValidity() === false) {
      event.preventDefault()
      event.stopPropagation()
    } else {
      v = true;
    }
    setValidated(true);


    if (v) {
      const article = {
        name: name,
        slug: slug,
        // object: value,
        privateKey: privateKey,
        publicKey: publicKey,
        content: ''
      };
      if (editorRef.current) {
        let d = editorRef.current.getContent();
        if (d != '') {
          article.content = d;
        }
      }

      if (data != undefined) {
        const response = axios.put(process.env.REACT_APP_SERVER_URL + '/api/pm_methods/' + data.id, article, header).then((response) => {
          if(response.status == 200){
              alert('Збережено');
              navigate(`/payment-methods/update/${response.data.id}`);
          }
        });

      } else {
        const response = axios.post(process.env.REACT_APP_SERVER_URL + '/api/pm_methods', article, header).then((response) => {
          if(response.status == 201){
            alert('Збережено');
            navigate(`/payment-methods/update/${response.data.id}`);
          }
        });
      }
    }

  }


  return (
    <>
      <CAlert color="success" dismissible visible={visibleSuccess} onClose={() => setVisibleSuccess(false)}>Дані збережено!</CAlert>
      <CAlert color="danger" dismissible visible={visibleError} onClose={() => setVisibleError(false)}>Дані не збережено!</CAlert>
      <CForm onSubmit={handleSubmit}
        className="row g-3 needs-validation"
        noValidate
        validated={validated}
      >
        <div className="mb-3">
          <CFormLabel htmlFor="exampleFormControlInput1">Назва</CFormLabel>
          <CFormInput type="text" id="exampleFormControlInput1" value={name} onChange={(e) => setName(e.target.value)} feedbackValid="" autoComplete="off" required />
        </div>
        <div className="mb-3">
          <CFormLabel htmlFor="exampleFormControlInput1">Ключ</CFormLabel>
          <CFormInput type="text" id="exampleFormControlInput2" value={slug} onChange={(e) => setSlug(e.target.value)} feedbackValid="" autoComplete="off" required />
        </div>
        <div className="mb-3">
          <CFormLabel htmlFor="exampleFormControlInput1">Ключ публічний</CFormLabel>
          <CFormInput type="text" id="exampleFormControlInput2" value={publicKey} onChange={(e) => setPublicKey(e.target.value)} feedbackValid="" autoComplete="off"  />
        </div>
        <div className="mb-3">
          <CFormLabel htmlFor="exampleFormControlInput1">Ключ приватний</CFormLabel>
          <CFormInput type="text" id="exampleFormControlInput2" value={privateKey} onChange={(e) => setPrivateKey(e.target.value)} feedbackValid="" autoComplete="off"  />
        </div>
        {/* <div className="mb-3">
          <CFormLabel htmlFor="exampleFormControlInput1">Значення</CFormLabel>
          <CFormInput type="text" id="exampleFormControlInput2" value={value} onChange={(e) => setValue(e.target.value)} feedbackValid="" autoComplete="off" required />
        </div> */}
        <div className="mb-3">
          <CFormLabel htmlFor="exampleFormControlInput1">JSON дані на оплату</CFormLabel>
          <CFormTextarea id="exampleFormControlInput2" value={value} onChange={(e) => setValue(e.target.value)} rows={6}  />
        </div>
        <div className="mb-3">
          <Editor
            apiKey={apiKey}
            onInit={(evt, editor) => editorRef.current = editor}
            initialValue={(data != undefined) ? data.content : ''}
            init={{
              height: 500,
              // menubar: false,
              menubar: 'edit view insert format tools',
              // plugins: [
              //   'advlist autolink lists link image charmap print preview anchor',
              //   'searchreplace visualblocks code fullscreen',
              //   'insertdatetime media table paste code help wordcount'
              // ],
              plugins: [
                'advlist', 'autolink',
                'lists', 'link', 'image', 'charmap', 'preview', 'anchor', 'searchreplace', 'visualblocks',
                'fullscreen', 'insertdatetime', 'media', 'table', 'help', 'code'
              ],
              // toolbar: 'undo redo | formatselect | ' +
              //   'bold italic backcolor | alignleft aligncenter ' +
              //   'alignright alignjustify | bullist numlist outdent indent | ' +
              //   'removeformat | help',
              toolbar: 'undo redo | blocks fontname fontfamily fontsize | bold italic underline strikethrough superscript subscript | ' +
                'backcolor forecolor |' +
                'alignleft aligncenter alignright alignjustify | ' +
                'bullist numlist checklist outdent indent | removeformat | table help',
              font_size_formats: '10px 12px 14px 16px 18px 24px 36px 48px 72px',
              content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
            }}
          />
        </div>
        <CButton type="submit" color="success">Зберегти</CButton>
      </CForm>
    </>
  );

}

export default PaymentMethodsForm;